'use client';

import { useEffect, useRef } from 'react';
import { addEventSourceListener } from './useEventSource';

/**
 * Подписка на конкретный тип SSE-события для обновления локального state.
 * Используется для progress-событий, которые НЕ инвалидируют кеш,
 * а обновляют UI напрямую (прогресс-бар, статус генерации).
 *
 * @example
 * useEventSourceEvent('story.generation.progress', (payload) => {
 *   if (payload.storyId === storyId) {
 *     setProgress(payload.progress as number);
 *   }
 * });
 */
export function useEventSourceEvent(
  eventType: string,
  handler: (payload: Record<string, unknown>) => void,
) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    const remove = addEventSourceListener(eventType, (payload) => {
      handlerRef.current(payload);
    });
    return remove;
  }, [eventType]);
}
